export default function Breadcrumbs() {
  // TODO: Implement the rest of the component: https://stellar-health.atlassian.net/browse/AE-65
  // Return a string, as this component has multiple consumers that style it differently.
  return 'All tasks';
}
